import { useEffect, useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import BurgerMenu from '../components/Header/BurgerMenu';
import About from '../components/About/About';
import AboutMap from '../components/About/AboutMap';
import AboutUpperBlock from '../components/About/AboutUpperBlock';
import { AboutUpperLine, AboutBottomLine } from '../components/About/AboutLines';
import AboutAddresses from '../components/About/AboutAddresses';
import AboutService from '../API/AboutService';
import { baseURL } from '../index';


function AboutPage() {
    // Тексты страницы и офисы редактируются в админке (раздел "Тексты About")
    const [about, setAbout] = useState(null);

    useEffect(() => {
        AboutService.getAbout()
            .then(response => setAbout(response.data))
            .catch(error => console.log('Не удалось загрузить тексты About: ' + error));
    }, []);

    return (
      <>
        <BurgerMenu/>
        <Header/>
        <AboutUpperBlock id={'about'} text={about?.who_we_are}/>
        <AboutUpperLine />
        <AboutMap src={about?.map_image_url ? baseURL + about.map_image_url : null}/>
        <About text={about?.offices_text}/>
        <AboutAddresses offices={about?.offices}/>
        <AboutBottomLine />
        <Footer/>
      </>
    );
  }

  export default AboutPage;
